import React, { useState, useEffect } from "react";
import { PatternFormat } from "react-number-format";
import { validCPF, validCNPJ } from "../../hooks/utils/useFormat";
import { toast } from "react-toastify";

const InputDocument = props => {
  const { type, value, valueChange, disabled, required } = props;
  const _pattern =
    type === "cpf"
      ? {
          placeholder: "***.***.***-**",
          format: "###.###.###-##",
          length: 11,
        }
      : type === "cnpj"
        ? {
            // CNPJ tem 14 dígitos: 2+3+3+4+2. A máscara antiga tinha 15 `#`, o
            // que deslocava a exibição de todo CNPJ vindo da API
            // (11222333000155 aparecia como 112.223.330/0015-5) e impedia o
            // `isValid` de reconhecer um documento já salvo.
            placeholder: "**.***.***/****-**",
            format: "##.###.###/####-##",
            length: 14,
          }
        : null;
  const [isValid, setisValid] = useState(false);
  const invalidate = () => {
    setisValid(false);
    return false;
  };

  useEffect(() => {
    if (value) {
      (() => {
        let _value = value.replace(/[^0-9]/g, "");
        let _is_valid = String(_value || 0)?.length === _pattern?.length;
        if (!_is_valid) return invalidate();
        if ((type === "cpf" && !validCPF(_value)) || (type === "cnpj" && !validCNPJ(_value))) {
          toast.error(type === "cnpj" ? "CNPJ Inválido." : "CPF Inválido.", { toastId: "document_error" });
          return invalidate();
        }
        setisValid(true);
      })();
    }
  }, [value, type, _pattern?.length]);

  return (
    <PatternFormat
      data-required={required}
      data-required-valid={required && !!isValid}
      disabled={disabled}
      placeholder={_pattern?.placeholder}
      format={_pattern?.format}
      value={!value ? "" : value}
      onValueChange={__ev => {
        valueChange(String(__ev.value));
        if ((type === "cpf" && validCPF(__ev.value)) || (type === "cnpj" && validCNPJ(__ev.value))) {
          setisValid(true);
        }
      }}
      onKeyPress={__ev => {
        __ev.key === "Enter" && __ev.target.blur();
      }}
      {...props}
    />
  );
};

export default InputDocument;
